import type {SupportedLocales} from '@/lib/locale/locale'
import type {Order} from '@/models/orderModel'
import {createQueryConfig, NO_REFETCH_OPTIONS} from '@/utils/query/query'

export default createQueryConfig({
  order: (orderId: string) => ({
    data: {} as Order,
    params: [orderId] as const,
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  checkOutOrder: () => ({
    data: {} as Order | false | string,
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
  orders: (locale: SupportedLocales) => ({
    key: ['orders', locale],
    data: {} as Order[],
    options: {
      ...NO_REFETCH_OPTIONS,
    },
  }),
})
